import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ISettingsService } from "services/SettingsService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type TermsAndConditionsState = {
  TermsAndConditionsContent: string | undefined;
  TermsAndConditionsAccepted: boolean;
  Loading: boolean;
};

const initialState: TermsAndConditionsState = {
  TermsAndConditionsContent: "",
  TermsAndConditionsAccepted: false,
  Loading: false,
};

export const termsAndConditionsSlice = createSlice({
  name: "termsAndConditions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTermsAndConditions.rejected, (state) => {
        state.Loading = false;
        state.TermsAndConditionsContent = "";
      })
      .addCase(getTermsAndConditions.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getTermsAndConditions.fulfilled, (state, action) => {
        state.Loading = false;
        state.TermsAndConditionsContent = action.payload;
      })
      .addCase(acceptTermsAndConditions.rejected, (state) => {
        state.TermsAndConditionsAccepted = false;
        state.Loading = false;
      })
      .addCase(acceptTermsAndConditions.pending, (state) => {
        state.Loading = true;
      })
      .addCase(acceptTermsAndConditions.fulfilled, (state) => {
        state.Loading = false;
        state.TermsAndConditionsAccepted = true;
      });
  },
});

export const getTermsAndConditions = createAsyncThunk("TermsAndConditions/GetTermsAndConditions", async () => {
  const settingsService = container.get<ISettingsService>(SERVICE_TYPES.SettingsService);
  return await settingsService.getTermsAndConditions();
});

export const acceptTermsAndConditions = createAsyncThunk("TermsAndConditions/AcceptTermsAndConditions", async () => {
  const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  await clientPortalUsersService.acceptTermsAndConditions();
});

export const selectLoading = (state: RootState) => {
  return state.termsAndConditions.Loading;
};

export const selectTermsAndConditionsContent = (state: RootState) => {
  return state.termsAndConditions.TermsAndConditionsContent;
};

export const selectTermsAndConditionsAccepted = (state: RootState) => {
  return state.termsAndConditions.TermsAndConditionsAccepted;
};

export default termsAndConditionsSlice.reducer;
